import React from 'react'
import './Competition.css'
import ComingSoon from '../../Components/Common/ComingSoon/ComingSoon'

const Competition = () => {
  return (
    <div className="Competition">
        <ComingSoon />
    </div>
  )
}

export default Competition